export default {
      id: "plug-white-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#plug-white",
      toString: function () {
        return this.url;
      }
    }